import { SpringSystem } from "rebound";

/**
 * 运行动画。
 *
 * @param start 开始数字
 * @param end 结束数字
 * @param callback 动画过程中每一帧执行的回调函数
 */
function animate(start: number, end: number, callback: Function) {
  const springSystem = new SpringSystem();
  const spring = springSystem.createSpring();

  spring.addListener({
    onSpringUpdate: () => {
      const value = spring.getCurrentValue();
      callback(value);
    }
  });

  spring.setCurrentValue(start).setAtRest();
  spring.setEndValue(end);

  return () => {
    springSystem.deregisterSpring(spring);
    springSystem.removeAllListeners();
    spring.destroy();
  };
}

export default animate;